"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.__DEV__ = exports.usePropRef = exports.sendWithHermes = exports.removeDuplicates = void 0;
const hermes_channel_1 = __importDefault(require("hermes-channel"));
const react_1 = require("react");
const __DEV__ = process.env.NODE_ENV !== "production";
exports.__DEV__ = __DEV__;
function removeDuplicates(arr) {
    const s = new Set(arr);
    const it = s.values();
    return Array.from(it);
}
exports.removeDuplicates = removeDuplicates;
function sendWithHermes(event, message, shareConnectionBetweenTab) {
    hermes_channel_1.default.send(event, message, shareConnectionBetweenTab ? "all" : "current");
}
exports.sendWithHermes = sendWithHermes;
function usePropRef(prop) {
    const ref = react_1.useRef(prop);
    if (ref.current !== prop) {
        ref.current = prop;
    }
    return ref;
}
exports.usePropRef = usePropRef;
//# sourceMappingURL=utils.js.map